import {EnvironmentType} from './environment.type';

export const ENVIRONMENT: EnvironmentType = {
  production: false,
  environment: 'DEV',
  commitHash: 'dev',
};
